/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { GridColumnJustify } from '@veeam-vspc/shared/components';

import type { GridColumnProps } from '@veeam-vspc/shared/components';
import type { CloudConnectTenants } from '@veeam-vspc/models/web-controllers';

import { TopsGrid } from '../../../TopsGrid';
import { useCommonSettings } from '../../../../hooks';
import { TopDataUrls } from '../../../../enums';
import { ConfigSectionIds } from 'core/enums';


import type { TopsGridComponentWrapper } from '../../../../interfaces';

export const CloudConnectServersByTenants: React.FC<TopsGridComponentWrapper> = ({ maxNumberOfRows }) => {
    const settings =
        useCommonSettings<CloudConnectTenants>({
            maxNumberOfRows,
            getDataRequestUrl: TopDataUrls.CloudConnectServersByTenants,
        });
    const { lang } = settings;

    const columns: GridColumnProps<CloudConnectTenants>[] = [
        {
            id: 'name',
            title: lang.SERVER,
            cell: rowData => rowData.name,
        },
        {
            id: 'activeSubTenantsCount',
            title: lang.ACTIVE_SUBTENANTS,
            cell: rowData => rowData.activeSubTenantsCount,
            justify: GridColumnJustify.Right,
            headerJustify: GridColumnJustify.Right,
        },
        {
            id: 'activeTenantsCount',
            title: lang.ACTIVE_TENANTS,
            cell: rowData => rowData.activeTenantsCount,
            justify: GridColumnJustify.Right,
            headerJustify: GridColumnJustify.Right,
        },
        {
            id: 'totalTenantsCount',
            title: lang.TOTAL_N_OF_TENANTS,
            cell: rowData => rowData.totalTenantsCount,
            justify: GridColumnJustify.Right,
            headerJustify: GridColumnJustify.Right,
        },
    ];

    return (
        <TopsGrid
            title={lang.TOP_CLOUD_CONNECT_SERVERS_BY_TENANTS}
            columns={columns}
            sectionId={ConfigSectionIds.TopsInfrastructure}
            maxNumberOfRows={maxNumberOfRows}
            {...settings}
        />
    );
};
